module.exports = __webpack_public_path__ + "static/media/close.b4a6e97c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.svg
// module id = 123
// module chunks = 0